module.exports = {
  "occupations": [ 
    "Abattoir Process Worker",
    "Aboriginal and Torres Strait Islander Education Worker",
    "Aboriginal and Torres Strait Islander Health Liaison Officer",
    "Aboriginal and Torres Strait Islander Health Worker",
    "Accountant",
    "Accounting Practice Manager",
    "Accounts Clerk",
    "Actor",
    "Actuarial Clerk",
    "Actuary",
    "Acupuncturist",
    "Administration",
    "Administration Assistant",
    "Administrative  Service Officer",
    "Admissions Clerk",
    "Advertising Director",
    "Advertising Manager",
    "Advertising Specialist",
    "Aerobics Instructor",
    "Aeronautical Engineer",
    "Aeroplane Pilot",
    "Aged or Disabled Carer",
    "Agent",
    "Agricultural Engineer",
    "Agricultural Field Officer",
    "Agricultural Scientist",
    "Agricultural Technician",
    "Agronomist",
    "Air Conditioning Mechanic",
    "Air Conditioning and Mechanical Services Plumber",
    "Air Force",
    "Air Force Junior Non-Commissioned offier",
    "Air Force Junior Officer",
    "Air Force Senior Non-Commissioned Officer",
    "Air Force Senior Officer",
    "Air Safety Inspector or Investigator",
    "Air Traffic Controller",
    "Aircraft Draftsperson",
    "Aircraft Maintenance Engineer",
    "Aircraft Navigator",
    "Aircraft Refueller",
    "Airline Employee",
    "Airline Steward",
    "Airways Surveyor",
    "Airworthiness Surveyor",
    "Alumina Refinery Operator",
    "Ambassador",
    "Ambulance Officer",
    "Amusement Centre Manager",
    "Amusement Park Attendant",
    "Anaesthetic Technician",
    "Anaesthetist",
    "Analyst Programmer",
    "Animal Attendant",
    "Animal Trainer",
    "Announcer",
    "Antique Dealer",
    "Apiarist",
    "Apparel Cutter",
    "Applications Programmer",
    "Apprentice or Trainee",
    "Aquaculture Farmer or Farm Overseer",
    "Aquaculture Worker",
    "Arborist",
    "Arc Welder",
    "Archbishop",
    "Architect",
    "Architectural Draftsperson",
    "Architectural Practice Manager",
    "Archivist",
    "Armoured Car Escort",
    "Army",
    "Army Junior Non-Commissioned Officer",
    "Army Junior Officer",
    "Army Senior Non-Commissioned Officer",
    "Army Senior Officer",
    "Art Director",
    "Art Teacher",
    "Articled Clerk",
    "Artist",
    "Artistic Director",
    "Arts Administrator",
    "Arts Manager",
    "Asbestos Removalist",
    "Assembler",
    "Assembly Line Worker",
    "Associate Editor",
    "Athlete",
    "Auctioneer",
    "Audio Engineer",
    "Audiologist",
    "Author",
    "Automotive Electrician",
    "Aviation Safety Inspector",
    "Back Hoe Operator",
    "Baggage Handler",
    "Baker",
    "Bakery Assistant",
    "Baking Factory Worker",
    "Ballet Teacher",
    "Band Member",
    "Bank Accountant",
    "Bank Employee",
    "Bank Manager",
    "Bank Officer",
    "Bank Teller",
    "Bar Useful or Busser",
    "Barber",
    "Barista",
    "Barrister",
    "Bartender",
    "Basketballer",
    "Beautician",
    "Beauty Salon Assistant",
    "Beauty Salon Manager",
    "Beauty Therapist",
    "Bed and Breakfast Owner Operator",
    "Bedding and Mattress Maker",
    "Beef Cattle Farm Worker",
    "Beef Cattle Farmer or Farm Overseer",
    "Betting Agency Manager",
    "Bicycle Mechanic",
    "Bingo Caller",
    "Biochemist",
    "Biologist",
    "Biomedical Engineer",
    "Biomedical Engineering Technician or Associate",
    "Biophysicist",
    "Biotechnologist",
    "Bishop",
    "Blacksmith",
    "Boarding Kennel or Cattery Operator",
    "Boat Builder or Repairer",
    "Boatswain",
    "Bobcat Operator",
    "Body Artist",
    "Body Builder",
    "Body Piercer",
    "Boiler Attendant",
    "Boilermaker",
    "Book Binder",
    "Book Editor",
    "Bookkeeper",
    "Bookmaker",
    "Bookmaker's Clerk",
    "Botanist",
    "Bottle Shop Attendant",
    "Bouncer",
    "Boxer",
    "Brewery Worker",
    "Brick Handler",
    "Bricklayer",
    "Bricklayer's Labourer",
    "Broadcast Transmitter Operator",
    "Builder",
    "Building Construction Labourer",
    "Building Construction Supervisor",
    "Building Designer",
    "Building Inspector",
    "Building Insulation Installer",
    "Building and Construction Manager",
    "Bulk Materials Handling Plant Operator",
    "Bulldozer Operator",
    "Bungy Jump Master",
    "Bus Conductor",
    "Bus Driver",
    "Bus Inspector",
    "Business Analyst",
    "Business Broker",
    "Business Development Officer",
    "Butcher",
    "Butler",
    "Buyer",
    "Cab Driver",
    "Cabinet Maker",
    "Cafe Manager",
    "Cafe Worker",
    "Cafeteria Worker",
    "Cake Decorator",
    "Call Centre Manager",
    "Call Centre Operator",
    "Call Centre Team Leader",
    "Camera Operator",
    "Camera Repairer",
    "Cane Cutter",
    "Cane Furniture Maker",
    "Canteen Assistant",
    "Canteen Manager",
    "Canvas Goods Maker",
    "Car Detailer",
    "Car Park Attendant",
    "Car Salesperson",
    "Car Wash Attendant",
    "Caravan Park Manager",
    "Caravan Salesperson",
    "Cardiac Technician",
    "Cardiologist",
    "Cardiothoracic Surgeon",
    "Careers Adviser",
    "Careers Counsellor",
    "Caretaker",
    "Carpenter",
    "Carpenter and Joiner",
    "Carpet Cleaner",
    "Carpet Layer",
    "Cartographer",
    "Cash Van Salesperson",
    "Cashier",
    "Casino Worker",
    "Casting Director",
    "Caterer",
    "Cellarhand",
    "Cement Plant Hand or Labourer",
    "Cement Production Plant Operator",
    "Cement Renderer",
    "Ceramics Scientist",
    "Change Management Facilitator",
    "Chaplain",
    "Charter Bus Driver",
    "Chartered Accountant",
    "Chauffeur",
    "Checkout Operator",
    "Cheesemaker",
    "Chef",
    "Chemical Engineer",
    "Chemical Engineering Technician",
    "Chemical Plant Hand or Labourer",
    "Chemical Plant Operator",
    "Chemical Production Machine Operator",
    "Chemist",
    "Chemist Shop Assistant",
    "Chemistry Technician",
    "Chief Executive Officer",
    "Chief Information Officer",
    "Child Care Aide or Worker",
    "Child Care Centre Director",
    "Child Care Worker",
    "Child Minder",
    "Child or Youth Residential Care Assistant",
    "Chimney Sweep",
    "Chinese Medicine Practitioner",
    "Chiropractor",
    "Chocolate Packer",
    "Choreographer",
    "Cinema Attendant",
    "Cinema Manager",
    "Circus Performer",
    "Civil Celebrant",
    "Civil Engineer",
    "Civil Engineering Draftsperson",
    "Civil Engineering Technician or Associate",
    "Claims Consultant",
    "Classer",
    "Classified Advertising Clerk",
    "Cleaner",
    "Clergy",
    "Clerk",
    "Clerk of Court",
    "Client Service Manager",
    "Clinical Coder",
    "Clinical Haematologist",
    "Clinical Psychologist",
    "Clock and Watch Maker and Repairer",
    "Cloth Cutter",
    "Clothing Designer",
    "Clothing Factory Hand or Labourer",
    "Clothing Pattern Maker",
    "Club Licensee",
    "Club Manager",
    "Coach Driver",
    "Coal Miner",
    "Coding Clerk",
    "Comedian",
    "Commercial Artist",
    "Commercial Traveller",
    "Commission Agent",
    "Commissioned Fire Officer",
    "Commissioned Police Officer",
    "Commodities Broker",
    "Communications Equipment Tradesperson",
    "Communications  Officer",
    "Communications Operator",
    "Community Arts Worker",
    "Community Support Worker",
    "Company Representative",
    "Company Secretary",
    "Compliance Officer",
    "Composer",
    "Compositor",
    "Computer Network and Systems Engineer",
    "Computer Programmer",
    "Computer Servicer or Technician",
    "Computer Systems Administrator",
    "Computing  Professional",
    "Computing Systems Analyst",
    "Concierge",
    "Concrete Batching Plant Operator",
    "Concrete Mixer Driver",
    "Concrete Plasterer",
    "Concrete Products Machine Operator",
    "Concrete Pump Operator",
    "Concrete Worker",
    "Conductor",
    "Confectioner",
    "Conference and Event organiser",
    "Conservation Officer",
    "Conservator",
    "Console Operator",
    "Construction Estimator",
    "Construction Project Manager",
    "Construction  Worker",
    "Consultant",
    "Contact Centre Manager",
    "Contact Centre Operator",
    "Contact Centre Team Leader",
    "Container Filler",
    "Continuity Person",
    "Contract Administrator",
    "Conveyancer",
    "Cook",
    "Cooper",
    "Coppersmith",
    "Copywriter",
    "Coroner",
    "Corporate General Manager",
    "Corporate Services Manager",
    "Corporate Treasurer",
    "Correctional Institution Governor",
    "Cosmetician",
    "Cost Clerk",
    "Costume Maker",
    "Cotton Grower",
    "Councillor",
    "Counselling Psychologist",
    "Counsellor",
    "Courier",
    "Court Bailiff or Sheriff",
    "Court Orderly",
    "Court Registrar",
    "Court Reporter",
    "Craft Worker",
    "Crane Chaser",
    "Crane Operator",
    "Creche Attendant",
    "Credit Union Employee",
    "Credit and Loans Officer",
    "Cricketer",
    "Crossing Supervisor",
    "Crosswalk Attendant",
    "Crowd Controller",
    "Curtain Installer",
    "Curtain Maker",
    "Customer Service Manager",
    "Customs Agent",
    "Customs Investigator or Officer",
    "Cyclist",
    "Dairy Cattle Farmer or Farm Overseer",
    "Dairy Farm Employee",
    "Dairy Products Maker",
    "Dairy Quality Assurance Inspector",
    "Dance Teacher",
    "Dancer",
    "Dark Room Attendant",
    "Data Entry Operator",
    "Data Processing Manager",
    "Data Processing Operator",
    "Database Administrator",
    "Deaf Interpreter",
    "Debt Collector",
    "Deckhand",
    "Decorator",
    "Deer Farmer or Farm Overseer",
    "Defence Force Personnel",
    "Deli Assistant",
    "Delivery Driver",
    "Dental Assistant",
    "Dental Hygienist",
    "Dental Mechanic or Technician",
    "Dental Nurse",
    "Dental Prosthetist",
    "Dental Specialist",
    "Dental Therapist",
    "Dentist",
    "Dermatologist",
    "Desktop Publisher",
    "Detailer",
    "Detective",
    "Developer Programmer",
    "Diagnostic and Interventional Radiologist",
    "Die Maker",
    "Die Setter",
    "Dietitian",
    "Director",
    "Director of Photography",
    "Disabilities Support Officer",
    "Disc Jockey",
    "Dishwasher",
    "Distance Education Teacher",
    "Distiller",
    "Diver",
    "Diversional Therapist",
    "Diving Instructor",
    "Doctor",
    "Dog Handler or Trainer",
    "Door Attendant",
    "Door-to-Door Salesperson",
    "Drainage, Sewerage and Stormwater Labourer",
    "Drainer",
    "Drama Teacher",
    "Dredge Operator",
    "Dressmaker",
    "Driller's Assistant",
    "Drilling Plant Operator",
    "Drink Waiter",
    "Driving Instructor",
    "Drover",
    "Drug and Alcohol Counsellor",
    "Drummer",
    "Drycleaner",
    "Earth Science Technician",
    "Earthmoving Labourer",
    "Earthmoving Plant Operator",
    "Ecologist",
    "Economist",
    "Editor",
    "Education Advisor",
    "Education Reviewer",
    "Educational Psychologist",
    "Egg Grader",
    "Electoral Officer",
    "Electorate Officer",
    "Electrical Appliance Servicer",
    "Electrical Engineer",
    "Electrical Engineering Draftsperson",
    "Electrical Engineering Technician",
    "Electrical Fitter",
    "Electrical Lines Worker",
    "Electrical Mechanic",
    "Electrical Tester",
    "Electrical Trades Assistant or Labourer",
    "Electrician",
    "Electrician's Assistant",
    "Electronic Engineering Draftsperson",
    "Electronic Engineering Technician",
    "Electronic Instrument Fitter or Technician",
    "Electronics Engineer",
    "Electronics Tester",
    "Electroplater",
    "Emergency Medicine Specialist",
    "Emergency Service Worker",
    "Employment Office Clerk",
    "Endocrinologist",
    "Engineer",
    "Engineering Manager",
    "Engineering Patternmaker",
    "Engineering Technologist",
    "Engine or Boiler Operator",
    "English Language Teacher",
    "Engraver",
    "Enrolled Nurse",
    "Entertainer",
    "Environmental Adviser",
    "Environmental Auditor",
    "Environmental Consultant",
    "Environmental Engineer",
    "Environmental Manager",
    "Environmental Officer",
    "Environmental Scientist",
    "Equipment Hire Manager",
    "Equities Analyst",
    "Exam Supervisor",
    "Excavator Operator",
    "Executive Assistant",
    "Executive Director",
    "Exercise Physiologist",
    "Exhaust and Muffler Fitter",
    "Exporter",
    "External Auditor",
    "Fabric Factory Hand or Labourer",
    "Fabricator",
    "Facilities Administrator",
    "Facilities Manager",
    "Factory Manager",
    "Faculty Head",
    "Family Day Care Worker",
    "Family Support Worker",
    "Family and Marriage Counsellor",
    "Farm Hand",
    "Farm Machinery Operator",
    "Farmer or Farm Overseer",
    "Farrier",
    "Fashion Designer",
    "Fast Food Cook",
    "Faults Consultant",
    "Fellmongery Hand or Labourer",
    "Fence Erector",
    "Fettler",
    "Fibreglasser",
    "Filing Clerk",
    "Film Director",
    "Film Editor",
    "Finance Broker",
    "Finance Manager",
    "Finance Officer",
    "Financial Adviser",
    "Financial Analyst",
    "Financial Controller",
    "Financial Institution Branch Manager",
    "Financial Investment Manager",
    "Financial Planner",
    "Financial Risk Analyst",
    "Financial Risk Manager",
    "Fire Brigade Officer",
    "Fire Fighter",
    "Fire Investigator",
    "Fire Protection Equipment Technician",
    "Fire Risk Assessor",
    "Fire Safety Officer",
    "Fireperson",
    "First Aid Trainer",
    "Fish Hatchery Manager",
    "Fish and Chip Cook",
    "Fisheries Officer",
    "Fishing Guide",
    "Fishing Hand",
    "Fitness Centre Manager",
    "Fitness Instructor",
    "Fitter",
    "Fitter and Turner",
    "Fleet Manager",
    "Flight Attendant or Steward",
    "Flight Engineer",
    "Flight Service Officer",
    "Floor Finisher",
    "Floor Sander and Polisher",
    "Floor Tile Layer",
    "Floor Tiler",
    "Florist",
    "Flower Grower",
    "Flying Instructor",
    "Food Processing Machine Operator",
    "Food Technologist",
    "Footballer",
    "Footwear Factory Hand or Labourer",
    "Footwear Production Machine Operator",
    "Forest Ranger",
    "Forester",
    "Forestry Labourer",
    "Forestry Production Manager",
    "Forklift Driver",
    "Forms Designer",
    "Fraud Investigator",
    "Freight Clerk",
    "Freight Handler",
    "French Polisher",
    "Front End Loader Operator",
    "Fruit and Vegetable Factory Worker",
    "Fruit and Vegetable Inspector",
    "Fruit and Vegetable Packer",
    "Fruit or Nut Farm Worker",
    "Fruit or Nut Grower",
    "Fruit or Nut Picker",
    "Functions Coordinator",
    "Funds Administrator",
    "Funeral Attendant",
    "Government contracted undertaker",
    "Furnace Operator",
    "Furniture Designer",
    "Furniture Finisher",
    "Furniture Maker",
    "Furniture Packer",
    "Furniture Removalist",
    "Furniture Upholsterer",
    "Futures Trader",
    "Gallery Curator",
    "Gallery Technician",
    "Gallery or Museum Guide",
    "Gallery or Museum Technician",
    "Games Programmer",
    "Gaming Worker",
    "Garage Attendant",
    "Garage Mechanic",
    "Garbage Collector",
    "Garden Labourer",
    "Gardener",
    "Gas Plant Hand or Labourer",
    "Gas Plant Operator",
    "Gasfitter",
    "Gastroenterologist",
    "Gem Cutter and Polisher",
    "General Medical Practitioner",
    "Genetic Counsellor",
    "Geographer",
    "Geographic Information Systems Manager",
    "Geologist",
    "Geophysicist",
    "Geotechnical Engineer",
    "Glass Blower",
    "Glass Machine Operator",
    "Glass Plant Hand or Labourer",
    "Glassware Maker",
    "Glazier",
    "Goat Farmer or Farm Overseer",
    "Goldsmith",
    "Golfer",
    "Governess",
    "Grader Operator",
    "Grain Mill Worker",
    "Grain, Oilseed or Pasture Farm Worker",
    "Grain, Oilseed or Pasture Grower",
    "Grain and Livestock Farmer or Farm Overseer",
    "Grape Grower",
    "Graphic Designer",
    "Graphic Reproduction Tradesperson",
    "Grave Digger",
    "Grazier",
    "Greenkeeper",
    "Groundsperson",
    "Guard",
    "Guitarist",
    "Gunsmith",
    "Gym Instructor",
    "Gymnast",
    "Gymnastics Coach or Instructor",
    "Gynaecologist",
    "Hair Salon Assistant",
    "Hair Salon Manager",
    "Hairdresser",
    "Hamburger Cook or Maker",
    "Handyperson",
    "Hansard Reporter",
    "Harvester Operator",
    "Hat Maker",
    "Head of School",
    "Health Information Manager",
    "Health Inspector",
    "Health Practice Manager",
    "Health Promotion Officer",
    "Health and Welfare Service Manager",
    "Helicopter Pilot",
    "Herbalist",
    "Hide and Skin Processing Machine Operator",
    "Hide or Skin Classer",
    "High School Teacher",
    "Hire Car Driver",
    "Historian",
    "Hoist Operator",
    "Home Companion",
    "Home Duties",
    "Homeopath",
    "Horse Breaker or Trainer",
    "Horse Breeder",
    "Horse Riding Coach or Instructor",
    "Horticulturist",
    "Hospital Orderly",
    "Hospital Pharmacist",
    "Hospitality Employee",
    "Host",
    "Hostel Manager",
    "Hostel Parent",
    "Hotel Manager",
    "Hotel Receptionist",
    "Hotel Service Manager",
    "House Painter",
    "Housekeeper",
    "Human Resource Clerk",
    "Human Resource Manager",
    "Human Resource Officer",
    "Hunter-Trapper",
    "Hunting Guide",
    "IT Account Manager",
    "IT Business Analyst",
    "IT Business Development Manager",
    "IT Customer Support Officer",
    "IT Hardware Technician",
    "IT Help Desk Officer",
    "IT Manager",
    "IT Network Administrator",
    "IT Network Analyst",
    "IT Professional",
    "IT Project Manager",
    "IT Quality Assurance Engineer",
    "IT Sales Assistant",
    "IT Sales Representative",
    "IT Security Specialist",
    "IT Support Engineer",
    "IT Systems Test Engineer",
    "IT Technician",
    "IT Trainer",
    "Illustrator",
    "Imam",
    "Immigration Officer",
    "Import-Export Clerk",
    "Importer",
    "Industrial Designer",
    "Industrial Engineer",
    "Industrial Pharmacist",
    "Industrial Relations Manager",
    "Industrial Relations Officer",
    "Industry Analyst",
    "Infant School Teacher",
    "Inquiry Clerk",
    "Inspector",
    "Installer",
    "Insurance Agent or Salesperson",
    "Insurance Assessor",
    "Insurance Broker",
    "Insurance Consultant or Clerk",
    "Insurance Investigator",
    "Insurance Loss Adjuster",
    "Insurance Risk Surveyor",
    "Integration Aide",
    "Intelligence Officer",
    "Intensive Care Specialist",
    "Interior Decorator",
    "Interior Designer",
    "Internal Auditor",
    "Interpreter",
    "Investigator",
    "Investment Broker",
    "Investment Dealer",
    "Iron Worker",
    "Ironer or Presser",
    "Jackaroo",
    "Janitor",
    "Jeweller",
    "Jewellery Designer",
    "Jillaroo",
    "Jockey",
    "Joiner",
    "Judge",
    "Judicial Registrar",
    "Keno Terminal Operator",
    "Key Account Manager",
    "Key Cutter",
    "Keyboard Operator",
    "Kiln Hand or Labourer",
    "Kiln Operator",
    "Kindergarten Assistant",
    "Kindergarten Teacher",
    "Kitchen Hand",
    "Knife Sharpener",
    "Knitting Machine Operator",
    "Knowledge Manager",
    "Laboratory Manager",
    "Labourer",
    "Ladies' Hairdresser",
    "Lagger",
    "Land Economist",
    "Landscape Architect",
    "Landscape Gardener",
    "Laundrette Owner",
    "Laundry Worker",
    "Law Clerk",
    "Lawn Mower",
    "Lawyer",
    "Lay Preacher",
    "Leaflet or Newspaper Deliverer",
    "Leather Goods Maker",
    "Legal Executive",
    "Legal Practice Manager",
    "Legal Secretary",
    "Legal and Related Clerks",
    "Liaison Officer",
    "Librarian",
    "Library Assistant",
    "Library Officer",
    "Library Technician",
    "Life Assurance Representative",
    "Life Science Technician",
    "Life Scientist",
    "Lifeguard",
    "Lift Mechanic",
    "Lift Operator",
    "Lighting Technician",
    "Linemarker",
    "Livestock Farm Worker",
    "Livestock and Mixed Crop Farm Worker",
    "Livestock and Mixed Crop Farmer or Farm Overseer",
    "Loadmaster",
    "Lobbyist",
    "Local Government Legislator",
    "Locksmith",
    "Locomotive Driver",
    "Lodge Manager",
    "Logging Assistant",
    "Logging Plant Operator",
    "Logging Worker",
    "Lorry Driver",
    "Luggage Porter",
    "Machine Shorthand Reporter",
    "Magistrate",
    "Mail Clerk",
    "Mailing Service Hand or Labourer",
    "Maintenance Planner",
    "Make-Up Artist",
    "Management Accountant",
    "Manager",
    "Managing Director",
    "Manicurist",
    "Manufacturer",
    "Manufacturing Company Manager",
    "Marina Manager",
    "Marine Biologist",
    "Marine Certification and Surveillance Manager",
    "Marine Engineer",
    "Marine Engineer Surveyor",
    "Marine Navigator",
    "Marine Safety Officer",
    "Marine Steward",
    "Market Gardener",
    "Market Research Analyst",
    "Market Research Interviewer",
    "Marketing Manager",
    "Marketing Specialist",
    "Massage Therapist",
    "Masseur or Masseuse",
    "Master Fisher",
    "Materials Engineer",
    "Materials Recycler",
    "Mathematician",
    "Meat Boner and Slicer",
    "Meat Inspector",
    "Meat Packer",
    "Meat Process Worker",
    "Meatworker",
    "Mechanic",
    "Mechanical Engineer",
    "Mechanical Engineering Draftsperson",
    "Mechanical Engineering Technician or Associate",
    "Mechanic's Assistant",
    "Media Officer",
    "Media Planner",
    "Medical Administrator",
    "Medical Laboratory Scientist",
    "Medical Laboratory Technician",
    "Medical Oncologist",
    "Medical Physicist",
    "Medical Radiation therapist",
    "Medical Receptionist",
    "Medical Secretary",
    "Medical Technician",
    "Medical Typist",
    "Member of Parliament",
    "Men's Hairdresser",
    "Merchandiser",
    "Merchant Seaman",
    "Messenger",
    "Metal Fabricator",
    "Metal Machinist",
    "Metal Polisher",
    "Metal Press Operator",
    "Metal Sprayer",
    "Metal Worker",
    "Metallurgical and Materials Technician",
    "Metallurgist",
    "Meteorologist",
    "Meter Reader",
    "Methods Analyst",
    "Microbiologist",
    "Microphone Boom Operator",
    "Middle School Teacher",
    "Midwife",
    "Migrant Teacher",
    "Migration Agent",
    "Miller",
    "Milliner",
    "Mine Deputy",
    "Mine Supervisor",
    "Miner",
    "Mining Blasting Worker",
    "Mining Draftsperson",
    "Mining Engineer",
    "Mining Labourer",
    "Mining Production Manager",
    "Mining Technician",
    "Minister of Religion",
    "Missionary",
    "Model",
    "Model Maker",
    "Monk",
    "Motel Manager",
    "Motel Receptionist",
    "Mothercraft Nurse",
    "Motion Picture Camera Operator",
    "Motion Picture Projectionist",
    "Motor Mechanic",
    "Motor Vehicle Accessories Fitter",
    "Motor Vehicle Body Builder",
    "Motor Vehicle Licence Inspector",
    "Motor Vehicle Painter",
    "Motor Vehicle Salesperson",
    "Motor Vehicle Trimmer",
    "Motor Vehicle Wrecker",
    "Motorcycle Mechanic",
    "Mountain Guide",
    "Multimedia Designer",
    "Multimedia Specialist",
    "Museum Curator",
    "Museum Registrar",
    "Museum Technician",
    "Museum or Gallery Guide",
    "Mushroom Picker",
    "Music Director",
    "Music Researcher",
    "Music Teacher",
    "Musical Instrument Repairer",
    "Musician",
    "Myotherapist",
    "Nanny",
    "Naturopath",
    "Naval Architect",
    "Navy",
    "Navy Junior Non-Commissioned Officer",
    "Navy Junior Officer",
    "Navy Senior Non-Commissioned Officer",
    "Navy Senior Officer",
    "Neurologist",
    "Neurosurgeon",
    "New Car Salesperson",
    "Newspaper Editor",
    "Newspaper Journalist",
    "Newspaper Photographer",
    "Newsreader",
    "Night Filler",
    "Night Watchperson",
    "Not stated",
    "Noxious Weeds and Pest Inspector",
    "Nuclear Medicine Technologist",
    "Nurse Consultant",
    "Nurse Educator",
    "Nurse Practitioner",
    "Nursery Assistant",
    "Nursery Hand",
    "Nurseryperson",
    "Nursing Agency Manager",
    "Nursing Assistant or Aide",
    "Nursing Clinical Director",
    "Nursing Sister",
    "Nursing Supervisor or Manager",
    "Obstetrician",
    "Occupational Health and Safety Adviser",
    "Occupational Medicine Specialist",
    "Occupational Therapist",
    "Office Administrator",
    "Office Cleaner",
    "Office Machine Mechanic",
    "Office Manager",
    "Office Secretary or Stenographer",
    "Office Trainee",
    "Office Worker",
    "Oil Rig Worker",
    "Opal Miner",
    "Opera Singer",
    "Operating theatre Technician",
    "Ophthalmologist",
    "Optical Dispenser",
    "Optical Mechanic",
    "Optometrist",
    "Order Clerk",
    "Organisational Psychologist",
    "Organist",
    "Orthopaedic Surgeon",
    "Orthoptist",
    "Orthotist",
    "Osteopath",
    "Other",
    "Otorhinolaryngologist",
    "Outdoor Adventure Guide",
    "Outdoor Adventure Instructor",
    "Owner - Bus, Truck, Limousine or Hire Car",
    "Owner-Driver",
    "Owner - Taxi",
    "Oyster Farmer or Farm Overseer",
    "Packer",
    "Paediatric Surgeon",
    "Paediatrician",
    "Paint Factory Hand or Labourer",
    "Paint Maker",
    "Painter",
    "Painter and Decorator",
    "Panel Beater",
    "Paper Mill Operator",
    "Paper Products Machine Operator",
    "Paper Products Maker",
    "Paper and Pulp Mill Worker",
    "Paperhanger",
    "Paralegal",
    "Paramedic",
    "Park Ranger",
    "Parking Inspector",
    "Parole Officer",
    "Passenger Coach Driver",
    "Pastry Cook",
    "Pastry Cook's Assistant",
    "Patents Examiner",
    "Pathologist",
    "Pathology Collector",
    "Patternmaker-Grader",
    "Paving Plant Operator",
    "Paving and Surfacing Labourer",
    "Payroll Clerk",
    "Payroll Guard",
    "Performing Artist",
    "Performing Arts Road Manager",
    "Periodical Editor",
    "Personal Assistant",
    "Personal Care Assistant",
    "Personnel Officer",
    "Personnel Records Clerk",
    "Personnel and Industrial Relations Manager",
    "Pest Controller",
    "Pest and Noxious Weeds Inspector",
    "Pet Groomer",
    "Petroleum Engineer",
    "Petroleum Plant Operator",
    "Pharmacist",
    "Pharmacy Assistant",
    "Pharmacy Technician",
    "Phlebotomist",
    "Photographer",
    "Photographic Developer and Printer",
    "Photographic Laboratory Assistant",
    "Photographic Studio Assistant",
    "Physicist",
    "Physio Assistant",
    "Physiologist",
    "Physiotherapist",
    "Pianist",
    "Piano Tuner",
    "Picture Framer",
    "Pig Farmer or Farm Overseer",
    "Pizza Chef or Maker",
    "Pizza Deliverer",
    "Plasterer",
    "Plastic Cablemaking Machine Operator",
    "Plastic Compounding and Reclamation Machine Operator",
    "Plastic and Reconstructive Surgeon",
    "Plastics Fabricator or Welder",
    "Plastics Plant Hand or Labourer",
    "Plastics Press Machine Operator",
    "Plastics Technician",
    "Plate Maker",
    "Plumber",
    "Plumber's Assistant",
    "Plumbing Inspector",
    "Podiatrist",
    "Poker Machine Servicer",
    "Police Inspector",
    "Police Officer",
    "Policy Adviser or Analyst",
    "Policy and Planning Manager",
    "Polymer Scientist",
    "Post Office Clerk",
    "Post Office Manager",
    "Postal Delivery Officer",
    "Postal Sorting Officer",
    "Potter or Ceramic Artist",
    "Poultry Farm Hand",
    "Poultry Farmer or Farm Overseer",
    "Poultry Process Worker",
    "Powder Monkey",
    "Power Generation Plant Operator",
    "Pre-School Aide",
    "Pre-School Teacher",
    "Pressure Welder",
    "Pricing Clerk",
    "Priest",
    "Primary Health Organisation Manager",
    "Primary School Teacher",
    "Print Finisher",
    "Print Journalist",
    "Printer's Assistant",
    "Printer's Hand",
    "Printing Machinist",
    "Printing Table Worker",
    "Prison Governor",
    "Prison Officer or Warder",
    "Private Detective",
    "Private Investigator",
    "Process Worker",
    "Producer",
    "Product Examiner",
    "Product Grader",
    "Product Tester",
    "Production  Assistant",
    "Production Tally or Scheduling Clerk",
    "Production or Plant Engineer",
    "Professor",
    "Program Director",
    "Program Seller",
    "Program or Project Administrator",
    "Project Builder",
    "Proofreader",
    "Prospector",
    "Prosthetist",
    "Psychiatrist",
    "Psychologist",
    "Psychotherapist",
    "Public Health Physician",
    "Public Policy Manager",
    "Public Relations Manager",
    "Public Relations Officer",
    "Public Servant",
    "Publishing Director",
    "Pulp Mill Operator",
    "Purchasing Officer or Clerk",
    "Quality Assurance Manager",
    "Quality Auditor",
    "Quantity Surveyor",
    "Quarantine Inspector",
    "RAAF",
    "RAAF Junior Non-Commissioned Officer",
    "RAAF Junior Officer",
    "RAAF Senior Non-Commissioned Officer",
    "RAAF Senior Officer",
    "Rabbi",
    "Racecourse Official",
    "Racing Car Driver",
    "Radiation Oncologist",
    "Radiator Fitter",
    "Radio Announcer",
    "Radio Director",
    "Radio Dispatcher",
    "Radio Journalist",
    "Radio Presenter",
    "Radio Technician",
    "Radiocommunications Technician",
    "Radiographer",
    "Rag Cutter",
    "Railway Signal Operator",
    "Railway Station Manager",
    "Railway Track Plant Operator",
    "Railway Track Worker",
    "Railway Worker",
    "Real Estate Agency Manager",
    "Real Estate Agent",
    "Real Estate Property Manager",
    "Real Estate Salesperson",
    "Receiving and Dispatching Clerk",
    "Receptionist",
    "Records Administrator",
    "Recreation Officer",
    "Recruitment Consultant",
    "Recruitment Officer",
    "Recycling Worker",
    "Referee",
    "Refrigeration Mechanic",
    "Refuge Worker",
    "Regional Education Manager",
    "Registered Nurse",
    "Registrar",
    "Rehabilitation Counsellor",
    "Religious Assistant",
    "Religious Leader",
    "Remedial Teacher",
    "Removalist",
    "Renal Medicine Specialist",
    "Rental Salesperson",
    "Repairer",
    "Research Nurse",
    "Research and Development Manager",
    "Reservations Clerk",
    "Resident Medical Officer",
    "Residential Care Officer",
    "Respite Carer",
    "Restaurant Manager",
    "Retail Assistant",
    "Retail Loss Prevention Officer",
    "Retail Store Manager",
    "Retail Supervisor",
    "Retail Trainee",
    "Retirement Village Manager",
    "Rheumatologist",
    "Rigger",
    "Road Maintenance Worker",
    "Road Roller Operator",
    "Road Traffic Controller",
    "Roof Plumber",
    "Roof Tiler",
    "Roof Truss Detailer",
    "Rubber Factory Hand or Labourer",
    "Rubbish or Recycling Collector",
    "Safety Inspector",
    "Sailmaker",
    "Sailor",
    "Sales Assistant",
    "Sales Clerk",
    "Sales Consultant",
    "Sales Demonstrator",
    "Sales Director or Manager",
    "Sales Representative",
    "Sales and Marketing Manager",
    "Salesperson",
    "Sand-Blaster",
    "Sandwich Hand",
    "Saw Operator",
    "Saw Repairer",
    "Saw Sharpener",
    "Sawmill Labourer",
    "Sawmilling Operator",
    "Scaffolder",
    "School Cleaner",
    "School Laboratory Technician",
    "School Principal",
    "School Services Officer",
    "Scrap Merchant",
    "Screen Printer",
    "Script Editor",
    "Sculptor",
    "Seafarer",
    "Seafood Farmer or Farm Overseer",
    "Seafood Packer",
    "Seafood Process Worker",
    "Secondary School Teacher",
    "Securities and Finance Dealer",
    "Security Consultant",
    "Security Door Installer",
    "Security Guard",
    "Security Officer",
    "Security Worker",
    "Semi-Trailer Driver",
    "Service Station Attendant",
    "Servicer",
    "Sewing Machinist",
    "Shearer",
    "Shearing Shed Hand",
    "Sheep Farm Worker",
    "Sheep Farmer or Farm Overseer",
    "Sheetmetal Trades Worker",
    "Shelf Filler",
    "Sheltered Workshop Hand or Labourer",
    "Shipbuilding Draftsperson",
    "Shipping Clerk",
    "Ship's Captain or Master",
    "Ship's Officer",
    "Ship's Purser",
    "Shipwright",
    "Shoemaker or Repairer",
    "Shooter or Trapper",
    "Shop Assistant",
    "Shop Fitter",
    "Shop Manager",
    "Short Order Cook",
    "Shot Firer",
    "Showroom Worker",
    "Sign Erector",
    "Signwriter",
    "Silversmith",
    "Singer",
    "Ski Instructor",
    "Skills Auditor",
    "Slaughterer",
    "Small Engine Mechanic",
    "Small Offset Printer",
    "Smallgoods Maker",
    "Snack Bar Assistant",
    "Soccer Player",
    "Social Scientist",
    "Social Security Assessor",
    "Social Worker",
    "Software Engineer",
    "Software Tester",
    "Soil Scientist",
    "Soil Technician",
    "Solicitor",
    "Sonographer",
    "Sound Engineer or Technician",
    "Spatial Science Technician",
    "Spatial Scientist",
    "Special Education Teacher",
    "Special Effects Person",
    "Special Needs Teacher",
    "Specialist Physician",
    "Speech Pathologist",
    "Speech Therapist",
    "Sports Administrator",
    "Sports Centre Manager",
    "Sports Coach",
    "Sports Development Officer",
    "Sports Instructor",
    "Sports Physician",
    "Sports Psychologist",
    "Sports Scientist",
    "Sportsperson",
    "Spray Painter",
    "Squash Player",
    "Stable Hand",
    "Stable Manager",
    "Staff Development Officer",
    "Stage Director",
    "Stage Manager",
    "Stagehand",
    "State Governor",
    "Stationhand",
    "Statistical Clerk",
    "Statistician",
    "Steel Erector",
    "Steel Fixer",
    "Stenographer",
    "Sterilisation Technician",
    "Stevedore",
    "Steward",
    "Stock Clerk",
    "Stock Exchange Dealer",
    "Stock and Station Agent",
    "Stockbroker",
    "Stockbroking Clerk",
    "Stone Processing Machine Operator",
    "Stonemason",
    "Storeperson",
    "Stores Clerk",
    "Strapper",
    "Street Vendor",
    "Streetsweeper Operator",
    "Structural Draftsperson",
    "Structural Engineer",
    "Structural Steel Detailer",
    "Student",
    "Student Counsellor",
    "Student Enrolled Nurse",
    "Student Registered Nurse",
    "Studio Hand",
    "Sub Editor",
    "Sugar Cane Grower",
    "Sugar Mill Worker",
    "Supply and Distribution Manager",
    "Surfer",
    "Surgeon",
    "Surveying Technician",
    "Surveying or Spatial Science Technician",
    "Surveyor",
    "Surveyor's Assistant",
    "Swimmer",
    "Swimming Instructor",
    "Swimming Pool Attendant",
    "Switchboard Operator",
    "Systems Programmer",
    "Tab Clerk",
    "Tafe Registrar",
    "Tailor",
    "Tanker Driver",
    "Tannery Hand or Labourer",
    "Tattooist",
    "Tax Agent or Consultant",
    "Tax Investigator",
    "Taxi Driver",
    "Taxi Proprietor",
    "Taxi-Truck Driver",
    "Taxidermist",
    "Teacher",
    "Teacher of English to Speakers of Other Languages",
    "Teacher of the Hearing Impaired",
    "Teacher of the Sight Impaired",
    "Teacher's Aide",
    "Technical Cable Jointer",
    "Technical Director",
    "Technical Writer",
    "Telecommunications Cable Jointer or Repairer",
    "Telecommunications Engineer",
    "Telecommunications Field Engineer",
    "Telecommunications Lines Worker",
    "Telecommunications Network Engineer",
    "Telecommunications Network Planner",
    "Telecommunications Technical Officer",
    "Telecommunications Technician",
    "Telecommunications Trades Assistant",
    "Telecommunications and Data Cabler",
    "Telemarketer",
    "Telephone Technician",
    "Telephonist",
    "Television Announcer",
    "Television Director",
    "Television Equipment Operator",
    "Television Journalist",
    "Television Presenter",
    "Television Servicer or Repairer",
    "Tennis Coach",
    "Tennis Player",
    "Textile, Clothing and Footwear Mechanic",
    "Textile Dyeing and Finishing Machine Operator",
    "Textile Factory Hand or Labourer",
    "Textile Sewing Machinist",
    "Theatre Attendant",
    "Theatre Manager",
    "Theatrical Dresser",
    "Therapist",
    "Thoracic Medicine Specialist",
    "Ticket Collector",
    "Ticket Seller",
    "Ticket Writer",
    "Tiler",
    "Timber Yard Worker",
    "Tobacco Grower",
    "Toolmaker",
    "Tour Bus Driver",
    "Tourist Adviser or Officer",
    "Tourist Guide",
    "Tow Truck Driver",
    "Town Planner",
    "Tractor Operator",
    "Trades Assistant",
    "Traffic Controller",
    "Traffic Inspector",
    "Train Conductor",
    "Train Controller",
    "Train Driver",
    "Train Examiner",
    "Training Officer",
    "Tram Conductor",
    "Tram Driver",
    "Translator",
    "Transport Company Manager",
    "Transport Conductor",
    "Transport Dispatcher",
    "Transport Driver",
    "Transport Engineer",
    "Transport Operations Inspector",
    "Travel Agency Manager",
    "Travel Agent or Consultant",
    "Tree Faller",
    "Tree Surgeon",
    "Trekking Guide",
    "Tribunal Member",
    "Trolley Collector",
    "Truck Driver",
    "Truck Driver's Offsider",
    "Trust Officer",
    "Turf Grower",
    "Turner",
    "Typesetter",
    "Typist",
    "Tyre Fitter",
    "Tyre Retreader",
    "Umpire",
    "Undertaker",
    "Unemployed",
    "University Lecturer",
    "University Registrar",
    "University Tutor",
    "Upholsterer",
    "Urban and Regional Planner",
    "Urologist",
    "Used Car Salesperson",
    "Usher",
    "Valuer",
    "Van Driver",
    "Variety Artist",
    "Vascular Surgeon",
    "Vegetable Farm Worker",
    "Vegetable Grower",
    "Vegetable Picker",
    "Vending Machine Attendant",
    "Vending Machine Servicer",
    "Veterinarian",
    "Veterinary Nurse",
    "Veterinary Practice Manager",
    "Video Editor",
    "Video Production Manager",
    "Video Technician",
    "Vineyard Worker",
    "Vision Mixer",
    "Viticulturist",
    "Vocalist",
    "Vocational Education Teacher or Tutor",
    "Waiter",
    "Waitress",
    "Wall Tiler",
    "Ward Assistant",
    "Wardrobe Builder",
    "Wardrobe Coordinator or Assistant",
    "Warehouse Assistant",
    "Warehouse Manager",
    "Waste Water Plant Operator",
    "Water Inspector",
    "Water Plant Operator",
    "Waterside Worker",
    "Weaver",
    "Web Administrator",
    "Web Designer",
    "Web Journalist",
    "Web Programmer",
    "Weed Controller",
    "Weighbridge Operator",
    "Weight Loss Centre Manager",
    "Weight Loss Consultant",
    "Welder",
    "Welfare Centre Manager",
    "Welfare Officer",
    "Wharf Labourer",
    "Whitewater Rafting Guide",
    "Wholesaler",
    "Wholesaling Company Director",
    "Window Cleaner",
    "Window Dresser",
    "Windscreen Fitter",
    "Wine Maker",
    "Winery Cellarhand",
    "Wood Carver",
    "Wood Machinist",
    "Wood Processing Machine Operator",
    "Wood Turner",
    "Wood and Wood Products Factory Worker",
    "Wool Buyer",
    "Wool Classer",
    "Wool Handler",
    "Word Processing Operator",
    "Workplace Relations Adviser",
    "Yarn Carding and Spinning Machine Operator",
    "Youth Worker",
    "Zookeeper",
    "Zoologist"
  ],
  "languages": [
    "Aceh (alt name Acehnese)",
    "Acholi",
    "Adapted Sign Language",
    "Afrikaans",
    "Albanian",
    "Alyawarra",
    "American Sign Language (alt name ASL)",
    "Amharic",
    "Ancient Greek",
    "Anindilyakwa",
    "Anmatyerr (alt name Anmatyerre)",
    "Arabic",
    "Armenian",
    "Assyrian",
    "Australian Sign Language (alt name Auslan)",
    "Azari",
    "Azerbaijani",
    "Bangla",
    "Bari",
    "Bassa  (Liberian)",
    "Bielorussian",
    "Bosnian",
    "British Sign Language (alt name BSL)",
    "Bulgarian",
    "Bunuba",
    "Burarra",
    "Burmese",
    "Cantonese",
    "Catalan",
    "Cebuano",
    "Chaldean",
    "Chin",
    "Chin (Falam)",
    "Chin (Hakha)",
    "Chin (Khumi)",
    "Chin (Mara)",
    "Chin (Matu)",
    "Chin (Mizo) (alt name Mizo)",
    "Chin (Tedim)",
    "Chin (Zotung)",
    "Chinese (Translator Only)",
    "Chinese, Hakka",
    "Chinese, Min Nan",
    "Chiu-Chownese",
    "Cook Island Maori",
    "Croatian",
    "Czech",
    "Danish",
    "Dari",
    "Dinka",
    "Djambarrpuyngu",
    "Djapu",
    "Dutch",
    "Dutch/German",
    "Dyirbal",
    "Eastern Aranda (Arrernte)",
    "Eastern Arrernte",
    "English",
    "Esperanto",
    "Estonian",
    "Ethic Questions (Translator Only)",
    "Ewe",
    "Fiji Hindi (alt name Fijian Hindustani)",
    "Fijian",
    "Filipino",
    "Finnish",
    "Flemish",
    "French",
    "French/German",
    "French/Russian",
    "French/Spanish",
    "Fulfulde (alt name Fulani)",
    "Fur",
    "Fuzhou",
    "Gaelic",
    "Gajerrong",
    "Ganda",
    "Garawa",
    "Gbe, Waci (alt name Wachi)",
    "Geez",
    "Gen",
    "Georgian",
    "German",
    "German/Italian",
    "German/Spanish",
    "Gikuyu (alt.name Kikuyu)",
    "Greek",
    "Gujarati",
    "Gumatj",
    "Gunwinkgu",
    "Gupapuyngu",
    "Hakka",
    "Hamun",
    "Harari",
    "Hassaniyya",
    "Hazaragi",
    "Hebrew",
    "Hindi",
    "Hindustani",
    "Hiri-Motu",
    "Hmong",
    "Hokkien",
    "Hungarian",
    "Ibo",
    "Icelandic",
    "Ilocano",
    "Ilonggo",
    "Indonesian",
    "Italian",
    "Iwaidja",
    "Japanese",
    "Jaru",
    "Javanese",
    "Jingpho (alt name Kachin)",
    "Juba Arabic",
    "Kakwa",
    "Kala",
    "Kala Lagaw Ya (alt name Kala Kawaw Ya)",
    "Kannada",
    "Karen",
    "Karen, Pwo Eastern",
    "Karen, S'gaw",
    "Kariyarra",
    "Kashmiri",
    "Kaytej",
    "Kaytetye",
    "Kazakh",
    "Khmer",
    "Kija",
    "Kinyarwanda (alt.name Rwanda)",
    "Kiribati",
    "Kirundi (alt.name Rundi,Urund)",
    "Kisi, Southern (alt name Kissi), Liberia",
    "Kiswahili (See Swahili)",
    "Kongo, San Salvador (alt name Kikongo)",
    "Konkani",
    "Korean",
    "Krio",
    "Kriol",
    "Kriol (Fitzroy Valley)",
    "Kriol (Gurindji)",
    "Kriol (Kimberley)",
    "Kriol (Roper River)",
    "Kukatja",
    "Kunwinjku",
    "Kurdish (Kurmanji)",
    "Kurdish (Sorani)",
    "Kurdish, Southern (Feyli)",
    "Lao",
    "Latin",
    "Latvian",
    "Lebanese (refer to Arabic)",
    "Liberian English",
    "Lingala",
    "Lithuanian",
    "Liyagalawumirr",
    "Luganda",
    "Luritja",
    "Macedonian",
    "Ma'di",
    "Malay",
    "Malayalam",
    "Maltese",
    "Mandarin",
    "Mandingo",
    "Manjiljarra",
    "Marathi",
    "Martu Wangka",
    "Mauritian",
    "Melanesian Pidgin English",
    "Mende",
    "Meriam, Miriam-Mir",
    "Mina",
    "Miriuwung",
    "Modern Tiwi",
    "Mon",
    "Mongolian",
    "Motu",
    "Multani",
    "Murrinh-Patha",
    "NO LANGUAGE",
    "Nepali",
    "New Zealand Sign Language (alt name NZSL)",
    "Ngaanyatjarra",
    "Non-Conventional Sign Language",
    "Non Language Specifice",
    "Norwegian",
    "Nuer",
    "Nunggubuyu",
    "Nyangumarta",
    "Nyikina",
    "Oromo",
    "Other Conventional Sign Language",
    "Pali",
    "Pashto",
    "Persian",
    "Pidgin, Nigerian",
    "Pintupi-Luritja",
    "Pitjantjatjara",
    "Polish",
    "Portuguese",
    "Portuguese/Spanish",
    "Pukapukan",
    "Pulaar",
    "Punjabi",
    "Rohingya",
    "Romanian",
    "Russian",
    "Russian/Spanish",
    "Samoan",
    "Sanskrit",
    "Serbian",
    "Shan",
    "Shanghainese",
    "Shilluk",
    "Sindhi",
    "Sinhalese",
    "Slovak",
    "Slovene",
    "Somali",
    "Spanish",
    "Sundanese",
    "Swahili (alt.name Kiswahili)",
    "Swatow",
    "Swedish",
    "Syriac",
    "Taiwanese",
    "Tajiki",
    "Tamil",
    "Tatar",
    "Telugu",
    "Teo Chiew",
    "Tetum",
    "Thai",
    "Themne (alt name Temne)",
    "Tibetan",
    "Tigre",
    "Tigrinya",
    "Timorese Hakka",
    "Tiwi",
    "T'oishan",
    "Tongan",
    "Torres Strait Creole (alt name Yumplatok)",
    "Turkish",
    "Turkmen",
    "Twi",
    "Uighur, Uighurese  (see Uyghur)",
    "Ukrainian",
    "Urdu",
    "Uyghur (alt name Uighur, Uighurese)",
    "Uzbek",
    "Vietnamese",
    "Visayan",
    "Walmajarri",
    "Wangkatha",
    "Warlpiri",
    "Warumungu",
    "Western Aranda (Arrernte)",
    "Western Arrarnta",
    "Western Arrernte",
    "Wik-Mungkan",
    "Wolof",
    "Written English",
    "Yankunytjatjara",
    "Yanyuwa",
    "Yiddish",
    "Yindjibarndi",
    "Yoruba",
    "Zande",
    "Zo (alt name Zomi)",
  ]
}